var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    clipPath: "url(#clip0_332_23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7194 16.6447L13.7192 15.1447C13.7191 14.349 13.4029 13.586 12.8402 13.0235C12.2775 12.4609 11.5144 12.145 10.7188 12.1451L4.71875 12.146C3.9231 12.1461 3.16009 12.4623 2.59756 13.025C2.03504 13.5877 1.71909 14.3508 1.71921 15.1465L1.71944 16.6465",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.71771 9.14505C9.37457 9.1448 10.7175 7.80145 10.7173 6.14459C10.717 4.48774 9.37365 3.1448 7.7168 3.14505C6.05994 3.1453 4.717 4.48865 4.71725 6.14551C4.71751 7.80236 6.06086 9.1453 7.71771 9.14505Z",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.2194 16.6434L18.2192 15.1434C18.2186 14.4787 17.9973 13.833 17.5899 13.3077C17.1826 12.7824 16.6124 12.4073 15.9688 12.2412",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.9668 3.24219C13.6121 3.40731 14.1842 3.78253 14.5927 4.30867C15.0012 4.83482 15.223 5.48197 15.2231 6.14809C15.2232 6.81422 15.0016 7.46144 14.5932 7.98771C14.1849 8.51398 13.613 8.88936 12.9677 9.05469",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.966797 0.896484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.b0548797837489566befc8846fcb6c00.svg";
export { ForwardRef as ReactComponent };